import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "hk-section" }
const _hoisted_4 = { class: "hk-wrap" }
const _hoisted_5 = { class: "d-flex flex-wrap ga-3 mt-8" }
const _hoisted_6 = { class: "hk-section hk-section--tight" }
const _hoisted_7 = { class: "hk-wrap" }
const _hoisted_8 = { class: "feature-title" }
const _hoisted_9 = { class: "feature-text" }
const _hoisted_10 = { class: "hk-section" }
const _hoisted_11 = { class: "hk-wrap" }
const _hoisted_12 = { class: "hk-section hk-section--tight" }
const _hoisted_13 = { class: "hk-wrap" }
const _hoisted_14 = { class: "hk-footer" }
const _hoisted_15 = { class: "hk-wrap hk-footer__inner" }
const _hoisted_16 = { class: "hk-footer__socials" }
const _hoisted_17 = { class: "hk-footer__copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_connection_row = _resolveComponent("connection-row")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar),
      _createVNode(_component_v_main, {
        class: "hk-app-bg",
        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createVNode(_component_v_carousel, {
              height: _ctx.smAndDown ? 260 : 560,
              "show-arrows": "hover",
              cycle: "",
              "hide-delimiter-background": "",
              "hide-delimiters": false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (banner, i) => {
                  return (_openBlock(), _createBlock(_component_v_carousel_item, { key: i }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.smAndDown ? banner.small : banner.big,
                        class: "hero__img",
                        alt: "Hímzés banner"
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["height"])
          ]),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    lg: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "hk-card pa-6 pa-md-10 hk-fade-up" }, {
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "hk-heading hk-heading--accent mb-2" }, "Prémium minőségű gépi hímzés", -1)),
                          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hk-subheading mb-6" }, "Egyedi megoldások cégeknek és magánszemélyeknek", -1)),
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hk-lead" }, [
                            _createElementVNode("p", { class: "mb-4" }, " A gépi hímzés az egyik legidőtállóbb és legelegánsabb módja a textíliák díszítésének. Kiváló választás, ha tartós és exkluzív megjelenést szeretnél biztosítani ruházati termékeidnek vagy promóciós ajándékaidnak. "),
                            _createElementVNode("p", { class: "mb-4" }, " A hímzett minták nem fakulnak, nem kopnak le, így hosszú távon is megőrzik esztétikai értéküket. Modern hímzési technológiánknak köszönhetően részletgazdag, precíz és egyedi mintákat készítünk a legkülönbözőbb textíliákra – legyen szó céges logóról, feliratról, emblémáról vagy névre szóló ajándékról. "),
                            _createElementVNode("p", { class: "mb-0" }, " Szolgáltatásunkkal segítünk kiemelkedni a tömegből: egységes vállalati arculat, személyre szabott ajándékok vagy exkluzív textiltermékek – bármi legyen a cél. ")
                          ], -1)),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              size: "large",
                              variant: "flat",
                              "prepend-icon": "mdi-image-multiple",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('gallery')))
                            }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" Galéria megtekintése ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              color: "secondary",
                              size: "large",
                              variant: "outlined",
                              "prepend-icon": "mdi-phone",
                              onClick: _ctx.onConnectionClick
                            }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" Kérj ajánlatot ")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "hk-heading hk-heading--accent mb-10" }, "Miért válassz minket?", -1)),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (f, i) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: i,
                      cols: "12",
                      sm: "6",
                      lg: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "hk-card hk-card--hover feature-card pa-6 h-100" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["feature-icon", 'feature-icon--' + _ctx.featureColor(i)])
                            }, [
                              _createVNode(_component_v_icon, {
                                icon: f.icon,
                                size: "30"
                              }, null, 8, ["icon"])
                            ], 2),
                            _createElementVNode("h3", _hoisted_8, _toDisplayString(f.title), 1),
                            _createElementVNode("p", _hoisted_9, _toDisplayString(f.text), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "hk-heading hk-heading--accent mb-10" }, "Gyakran ismételt kérdések", -1)),
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    lg: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panels, {
                        variant: "accordion",
                        class: "hk-faq"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (item, i) => {
                            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                              key: i,
                              title: item.q,
                              text: item.a,
                              "collapse-icon": "mdi-minus",
                              "expand-icon": "mdi-plus",
                              rounded: "lg"
                            }, null, 8, ["title", "text"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "hk-heading hk-heading--accent mb-10" }, "Lépj velünk kapcsolatba", -1)),
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    lg: "10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "hk-card pa-4 pa-md-8" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_connection_row)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("footer", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "hk-footer__brand" }, [
                _createElementVNode("div", { class: "font-display hk-footer__title" }, "Kreatív Hímző Kuckó"),
                _createElementVNode("p", { class: "hk-footer__tagline" }, "Prémium gépi hímzés Kiskunfélegyházán")
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "hk-footer__follow" }, "Kövess minket", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (s) => {
                  return (_openBlock(), _createBlock(_component_v_btn, {
                    key: s.icon,
                    icon: s.icon,
                    href: s.href,
                    target: "_blank",
                    variant: "text",
                    color: "white",
                    size: "small"
                  }, null, 8, ["icon", "href"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, " © " + _toDisplayString(new Date().getFullYear()) + " — Kreatív Hímző Kuckó ", 1)
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}